module.exports = __webpack_public_path__ + "static/media/category-view-icon-list.37d34d2c.svg";